module.exports = __webpack_public_path__ + "img/lllogo.2c513db3.png";